module.exports = __webpack_public_path__ + "static/media/service3.32698236.webp";